import { ReactNode } from 'react'
import { StyledHeroText } from './Typography.styles'

export function HeroText(props: { sx?: any; children: ReactNode }) {
  const { sx, children } = props
  return <StyledHeroText sx={sx}>{children}</StyledHeroText>
}
